import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastService } from 'ng-uikit-pro-standard';
import { BancoService } from 'src/app/services/banco.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { PagoService } from 'src/app/services/pago.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalCambiarFechaComponent } from './modal-cambiar-fecha/modal-cambiar-fecha.component';
import { ModalSeleccionarClienteComponent } from '../../shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component';
import * as _ from 'lodash';
import { debounceTime, filter } from 'rxjs/operators';

@Component({
  selector: 'app-cheques-cambiar-fecha',
  templateUrl: './cheques-cambiar-fecha.component.html',
  styleUrls: ['./cheques-cambiar-fecha.component.scss'],
  providers: [SecurityService],
})
export class ChequesCambiarFechaComponent implements OnInit {

  @ViewChild('alert', { static: true }) alert: ElementRef;
  closeAlert() {
    this.alert.nativeElement.classList.remove('show');
  }

  // Modales
  @ViewChild(ModalCambiarFechaComponent, { static: true }) modalCambiarFecha: ModalCambiarFechaComponent
  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent
  @Output() onClienteChange: EventEmitter<any> = new EventEmitter<any>()

  // Form
  formHeader: FormGroup

  // data & tmp
  private rutEmpresa: number
  private sucursalEmpresa: number
  optionsBancos: Array<any> = [];
  listaPagos: Array<any> = null
  paginationContext: PaginationContext = new PaginationContext()
  clienteSeleccionado: any = null
  headerData: any = {}
  estadosPermitidos = [2, 3, 8];
  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private fb: FormBuilder,
    private toastrService: ToastService,
    private formValidatorsService: FormValidatorsService,
    private bancoService: BancoService,
    private pagoService: PagoService,
    private messageRendererService: MessageRendererService,
    private rutService: RutService,
    private datesService: DatesService
  ) {
    this.log = this.clog.log('CHEQUES-CAMBIAR-FECHA')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo())

    this.paginationContext.RecordsByPage = 10

    this.getBancos()
    this.createForm()
    this.formChangesSubscriptions()
  }

  private getBancos() {
    this.bancoService.obtenerSegunFiltro(
      '',
      true,
      ({ mensajes, respuesta }) => {
        const { registros } = respuesta
        this.optionsBancos = registros.map(banco => ({ value: banco.codigo, label: banco.nombre, ...banco }))
      }
    )
  }

  private createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formHeader = this.fb.group({
      fechaDesde: [initDate, [Validators.required]],
      fechaHasta: [currentDate, [Validators.required]],
      bancos: [[]],
      nroCheque: [null],
      rut: [null],
    });
  }

  private formChangesSubscriptions() {
    this.formHeader.get("rut").valueChanges
      .pipe(filter(Boolean), debounceTime(2000))
      .subscribe((rut: string) => {
        this.modalSeleccionarCliente.searchByRut(rut)
        this.modalSeleccionarCliente.cleanLast()
      })
  }

  abrirModalSeleccionarCliente() {
    this.modalSeleccionarCliente.show()
  }

  onClienteSeleccionado({ data, origen }) {
    this.clienteSeleccionado = data
    this.clienteSeleccionado.rutFormato = this.rutService.AgregarDV(this.clienteSeleccionado.rut)
    this.formHeader.get('rut').setValue(this.clienteSeleccionado.rutFormato)
    this.onClienteChange.emit(this.headerData.clienteSeleccionado)
  }

  onClienteNoEncontrado() {
    this.clienteSeleccionado = null
    this.clearClientData()
  }
  clearClientData() {
    this.clearContent()
    this.onClienteChange.emit(null)
  }
  clearContent() {
    this.headerData = {}
    this.formHeader.get('rut').setValue(null)
  }


  buscar(pageNumber) {
    this.paginationContext.CurrentPage = pageNumber

    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid)
      return

    const inputParams = this.createInputParams()
    this.log('buscar', JSON.stringify(inputParams))

    this.pagoService.obtenerChequeIngresados(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
      this.paginationContext.RecordsCount = totalRegistros
      this.paginationContext.CurrentPage = paginaActual
      this.paginationContext.PagesCount = totalPaginas
      this.listaPagos = registros
      this.listaPagos.map(pago => {
        pago.cliente_proveedor_rutFormato = this.rutService.AgregarDV(pago.cliente_proveedor_rut)
      })
    })
  }

  createInputParams() {
    this.log(this.formHeader.value)
    return {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        cliente_proveedor_rut: this.formHeader.get('rut').value === null || this.formHeader.get('rut').value === '' ? 0 : this.clienteSeleccionado.rut || 0,
        fecha_desde: this.formHeader.get('fechaDesde').value,
        fecha_hasta: this.formHeader.get('fechaHasta').value,
        bancos: this.formHeader.get('bancos').value,
        numero_doc: this.formHeader.get('nroCheque').value || 0
      },
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }
  }

  onPageChange(context: PaginationContext) {
    this.buscar(context.RequestedPage)
  }

  showModalCambioFecha({ codigo, numero_doc }) {
    this.modalCambiarFecha.loadAndShow(codigo, numero_doc)
  }

  cambioFechaRealizado(pago) {
    this.buscar(1)
  }

}
